import {useCallback, useEffect, useState} from "react";
import {getPayout} from "../api/eventGroupApiClient";

export const usePayout = (payoutId) => {
    const [payout, setPayout] = useState(null);

    const fetchPayout = useCallback(async () => {
        try {
            const data = await getPayout(payoutId);
            setPayout(data);
        }
        catch (error) {
            console.log(error);
        }
    }, [payoutId]);

    useEffect(() => {
        fetchPayout();
    }, [fetchPayout]);

    return {payout : payout};
};